import {useCalendarStore} from '@components/calendar/calendar-store'
import {addDays, isSameDay, toDate} from 'date-fns'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {Time} from 'yougile-util'
import {proportionPixelsDivideOnHour} from '../../utils'
import {getDashLine, getStraightLine} from '../nav/nav'
import IconPoint from './icon-point.svg'

interface Props {
  day: number
}

export const HourLine = observer(({day}: Props) => {
  const [, store] = useCalendarStore()
  const [, minuteTime] = store.currentHourAndMinute
  const top = minuteTime * proportionPixelsDivideOnHour - 1

  return (
    <div
      className="absolute z-20 w-full"
      style={{
        top
      }}
    >
      {isSameDay(
        addDays(store.startDate('current'), day),
        toDate(Time.now())
      ) && (
        <div className="absolute z-10 text-accent-old -bottom-10 -left-4">
          <IconPoint />
        </div>
      )}
      {isSameDay(addDays(store.startDate('current'), day), toDate(Time.now()))
        ? getStraightLine()
        : getDashLine()}
    </div>
  )
})
